import { BudgetSwitcher } from '@/components/budget-switcher/budget-switcher';
import { Logo } from '@/components/logo/logo';
import { NavigationItem, TabsOrDropdown } from '@/components/ui/tabs-or-dropdown';
import { useLocation, useNavigate } from 'react-router-dom';
import { useIsUserLoggedIn } from '@liquidbudget/common';
import { useTheme } from '@/theme';
import { Button } from '@/components/ui/button';
import { MoonIcon, SunIcon } from 'lucide-react';

const loggedOutItems: NavigationItem[] = [
  { value: '/', label: 'Features' },
  { value: '/how-it-works', label: 'How It Works' },
  { value: '/videos', label: 'Videos' },
  { value: '/about', label: 'About Us' },
  { value: '/sign-up', label: 'Sign Up' },
  { value: '/login', label: 'Login' },
];

const loggedInItems: NavigationItem[] = [
  { value: '/', label: 'Features' },
  { value: '/how-it-works', label: 'How It Works' },
  { value: '/videos', label: 'Videos' },
  { value: '/about', label: 'About Us' },
  { value: '/logout', label: 'Logout' },
];

interface Props {}

export const PublicLayoutHeader = ({}: Props) => {
  const loggedIn = useIsUserLoggedIn();
  const navigate = useNavigate();
  const location = useLocation();
  const { theme, setTheme } = useTheme();

  const toggleTheme = () => {
    setTheme(theme === 'dark' ? 'light' : 'dark');
  };

  const handleNavigation = (value: string) => {
    navigate(value);
  };

  return (
    <header className="sticky top-0 z-10 bg-sidebar h-14 flex items-center justify-between px-4">
      <div>
        {!loggedIn && <Logo />}
        {loggedIn && <BudgetSwitcher />}
      </div>
      <div className="flex items-center gap-2 ml-auto">
        <TabsOrDropdown
          items={loggedIn ? loggedInItems : loggedOutItems}
          value={location.pathname}
          onChange={handleNavigation}
        />
        <Button variant="ghost" size="icon" onClick={toggleTheme} aria-label="Toggle theme">
          {theme === 'dark' ? <SunIcon className="size-5" /> : <MoonIcon className="size-5" />}
        </Button>
      </div>
    </header>
  );
};
